<template>
<v-content style="height: 100%;" class="px-0 mx-auto">
    <v-row style="max-width: 600px; margin: 0 auto;" >
        <v-col id="base" md="12" style="height: 100%; " class="mt-0 pt-0" >
            <v-row justify="center" align="center" :style="{ 'background-color': $store.state.colors.primary }" class="pb-3">
                <v-img max-width="230px" height="80px" contain :src="$store.state.logoSRC"></v-img>
            </v-row>

            <v-row v-if="sucursalV()" justify="start" align="center" style="height:55px; background-color: #e6e6e6;" class="pt-0">
                <v-btn @click="$router.push({ name: 'menu'})" icon x-large :color="$store.state.colors.primary" style="margin-left: 30px;">
                <v-icon x-large >mdi-chevron-left</v-icon>
                </v-btn>
            </v-row>
            
           <v-row justify="center" class="mt-8 RestoBold" style="font-size: 22px; text-align: center">
               ¡Selecciona la sucursal que prefieras!
           </v-row>
           <v-row justify="center" align="start" class="mt-5" style="width: 95%; margin: 0 auto">
                <v-col>
                    <v-hover v-for="(address, index) in sucursales" :key="index" v-slot:default="{ hover }">
                        <v-card @click=" selectedSuc = index; openDialog();" :elevation="hover ? 5 : 0" style="background-color: #E6E6E6; border-radius: 5px;" width="100%" class="mt-3" >
                            <v-row class="px-4">
                                <v-col align-self="center" cols="auto">
                                    <v-img src='@/assets/resources/user/restaurante.svg' width="25px" height="25px"></v-img>
                                </v-col>
                                <v-col align-self="center" style="font-size: 12px" class="RestoRegular">
                                    <v-row class="RestoBold" style="font-size: 13px">
                                        {{address.sucursal}}
                                    </v-row>
                                    <v-row>
                                        {{address.calle}} #{{address.num_exterior}}, {{address.ciudad}}
                                    </v-row>
                                </v-col>
                                <v-col v-if="activeSuc(address.id_sucursal)" align-self="center" cols="auto" class="ml-2 mr-2" >
                                    <v-row justify="center">
                                        <v-icon small color="green">mdi-checkbox-blank-circle</v-icon>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-hover>
                </v-col>
            </v-row>

        </v-col>
        <v-dialog v-model="dialog" max-width="290" persistent >
            <v-card>
                <v-col>
                    <v-row class="RestoBold pt-4"  style="width: 90%; margin: 0 auto; font-size: 18px; text-align: center">
                        Si decides cambiar de sucursal tu pedido actual se perderá <br>¿Deseas continuar?    
                    </v-row>
                </v-col>

                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn @click="dialog= false;" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    No
                </v-btn>

                <v-btn @click="send_sucursal()" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                    Sí
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-if="alertNoAddresses" v-model="alertNoAddresses" max-width="400">
            <v-card>
                <v-row justify="center" align="center" style="color: white">
                    <v-col cols="auto">
                        
                        <v-row justify="center" class="pb-0 mb-0 pt-4 RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 23px">
                            No pudimos vincular una sucursal
                        </v-row>
                        <v-row justify="center" class="py-0 my-0 RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 23px">
                            a la dirección que añadiste,
                        </v-row>
                        <v-row justify="center" class="py-0 my-0 RestoRegular" style="font-size: 18px;color:#4D4D4D; line-height: 23px">
                            deberás seleccionar una sucursal
                        </v-row>
                    </v-col>
                </v-row>
                <v-row justify="center" class="mt-0">
                    <v-col calign-self="center" class="mt-0 pt-0" cols="auto">
                        <v-row justify="center" class="mt-0 pt-0">
                            <v-btn @click="closeDialog()" :color="$store.state.colors.primary" style="color: white" class="buttonLower">
                                Entendido
                            </v-btn>
                        </v-row> 
                    </v-col>                      
                </v-row>
            </v-card>
        </v-dialog>

    </v-row>
</v-content>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            alertNoAddresses: false,
            selectedSuc: null,
            dialog: false,
            sucursales: {},
            sucursal: "",
            name: localStorage.getItem("nombre_cliente"),
            selector: false,
        }
    },
    mounted() {
        if(localStorage.getItem("alertNoAddresses") == "true")
            this.alertNoAddresses = true;
    },
    created() {
        this.$store.state.logo = false;
        if(this.$route.params.selector == true)
            this.selector = this.$route.params.selector;
        axios.get('sucursales/' + this.$store.state.codigo_marca, {headers: {Authorization: this.$store.state.token}, timeout: 60000 })
        .then(response => {
            console.log(`%cRESPONSE`, 'color: green; font-weight: bold;', response);
            this.sucursales = response.data;
        })
        .catch(error => {
            console.log(`%cERROR`, 'color: red; font-weight: bold;', error);
        });
        
    },
    methods: 
    {
        openDialog() {
            if(localStorage.getItem("id_sucursal") == "0")
            {
                this.dialog = false;
                this.send_sucursal()
            }
            else   
                this.dialog = true;
        },
        activeSuc(id_sucursal){
            if(localStorage.getItem("solo_sucursal") == "Y" && id_sucursal == localStorage.getItem("id_sucursal"))
                return true;
            else
                return false;
        },
        closeDialog()
        {            
            this.alertNoAddresses = false;
        },
        goMenu() {
            localStorage.setItem("solo_sucursal", "N");
            localStorage.setItem("id_sucursal", localStorage.getItem('original_id_sucursal'));
            this.$router.push({ name: 'menu'});
        },
        selectorV() {
            if(localStorage.getItem('original_id_sucursal') == '0' || this.selector)
                return true
            else   
                return false
        },
        sucursalV() {
            
            if(localStorage.getItem('id_sucursal') == '0')
                return false
            else   
                return true
        },
        send_sucursal() {
            console.log(this.selectedSuc)
            this.$store.state.lista_platillos = []; 
            localStorage.setItem('platillos', JSON.stringify([]));
            var sucursalData = {
                calle: this.sucursales[this.selectedSuc].calle,
                ciudad: this.sucursales[this.selectedSuc].ciudad,
                num_exterior: this.sucursales[this.selectedSuc].num_exterior,
                sucursal: this.sucursales[this.selectedSuc].sucursal,
                telefono: this.sucursales[this.selectedSuc].telefono,
                sucursal_corto: this.sucursales[this.selectedSuc].sucursal_corto
            }
            // console.log(this.sucursales[this.selectedSuc].servicio )
            if(this.sucursales[this.selectedSuc].servicio != "activo")
                localStorage.setItem("Servicio", "true")
            else
                localStorage.setItem("Servicio", "false")

            localStorage.setItem("propinasBandera", this.sucursales[this.selectedSuc].propinas);
            localStorage.setItem("formas_aceptadas", this.sucursales[this.selectedSuc].formas_aceptadas);
            localStorage.setItem("sucursalData", JSON.stringify(sucursalData) );
            localStorage.setItem("minimo_pedido", this.sucursales[this.selectedSuc].minimo_pedido);
            localStorage.setItem("solo_sucursal", "Y");
            localStorage.setItem("id_sucursal", this.sucursales[this.selectedSuc].id_sucursal);
            this.$router.push({ name: 'menu'});
            this.dialog = false;
            localStorage.removeItem("alertNoAddresses");
        }
    }
   
}
</script>

<style scoped>
.disable-events 
{
    pointer-events: none;
}
.font
{
    font-size: 16px;
}

select {
        width: 100%;
        padding: 5px 20px;
        border: none;
        border-radius: 4px;
        background-color: transparent;
    }

/* select {
        display: block;
        background: transparent;
        line-height: 1;
        font-size: 20px;
        height: 40px;
        padding: 0px 1px 1px 2px;
        width: 100%;
        border-radius: 4px;
    }

    select:focus{ outline: none;}
    select::-ms-expand { display: block; } */
</style>